<app-dashboard-index *ngIf="this.dashboardId !== 0" [dashboardId]="this.dashboardId">
</app-dashboard-index>
